/**
 * AppICEMAP — SkeletonLoader
 * Loading placeholder with shimmer animation.
 *
 * Usage:
 *   <skeleton-loader type="card" count="3"></skeleton-loader>
 *
 * Types: card, text, circle, map-marker
 */

export class SkeletonLoader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this._render();
	}

	static get observedAttributes() {
		return ["type", "count", "lines"];
	}

	attributeChangedCallback() {
		if (this.isConnected) this._render();
	}

	_render() {
		const type = this.getAttribute("type") || "text";
		const count = parseInt(this.getAttribute("count"), 10) || 1;
		const lines = parseInt(this.getAttribute("lines"), 10) || 3;

		this.setAttribute("aria-busy", "true");
		this.setAttribute("aria-label", "Cargando...");
		this.className = `skeleton skeleton--${type}`;

		// Clear previous
		while (this.firstChild) this.firstChild.remove();

		if (type === "card") {
			for (let i = 0; i < count; i++) {
				const card = document.createElement("div");
				card.className = "skeleton__card";
				card.innerHTML = `
              <div class="skeleton__shimmer skeleton__icon"></div>
              <div class="skeleton__shimmer skeleton__title"></div>
              <div class="skeleton__shimmer skeleton__meta"></div>
            `;
				this.appendChild(card);
			}
		} else if (type === "text") {
			for (let i = 0; i < lines; i++) {
				const line = document.createElement("div");
				line.className = "skeleton__shimmer skeleton__line";
				// Vary widths
				const widths = ["90%", "75%", "85%", "60%", "95%"];
				line.style.width = widths[i % widths.length];
				this.appendChild(line);
			}
		} else if (type === "circle") {
			const circle = document.createElement("div");
			circle.className = "skeleton__shimmer skeleton__circle";
			this.appendChild(circle);
		} else if (type === "map-marker") {
			for (let i = 0; i < count; i++) {
				const marker = document.createElement("div");
				marker.className = "skeleton__shimmer skeleton__map-marker";
				this.appendChild(marker);
			}
		}
	}
}

customElements.define("skeleton-loader", SkeletonLoader);
